"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.advantagesNormalizer = void 0;
const mocks_json_1 = __importDefault(require("./mocks.json"));
/**
 * normalizador del modulo MODULO_RECOMENDACION
 * @param {object} fields
 * @returns
 */
const advantagesNormalizer = (data) => {
    var _a, _b, _c, _d, _e, _f;
    try {
        let res = null;
        const normalizedInfo = {};
        const title = ((_a = data === null || data === void 0 ? void 0 : data.fields) === null || _a === void 0 ? void 0 : _a.title) || ((_c = (_b = data === null || data === void 0 ? void 0 : data[0]) === null || _b === void 0 ? void 0 : _b.fields) === null || _c === void 0 ? void 0 : _c.title);
        const advantageList = ((_d = data === null || data === void 0 ? void 0 : data.fields) === null || _d === void 0 ? void 0 : _d.iconList) || ((_f = (_e = data === null || data === void 0 ? void 0 : data[0]) === null || _e === void 0 ? void 0 : _e.fields) === null || _f === void 0 ? void 0 : _f.iconList);
        if (title) {
            normalizedInfo["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-1"]), { text: title });
        }
        if (advantageList && Array.isArray(advantageList) && advantageList.length > 0) {
            advantageList.map((advantage, index) => {
                const normalizedAdvantage = {};
                const { fields } = advantage;
                const { icon, iconColor, iconHeight, iconWidth, description, title } = fields;
                const iconObject = {
                    id: icon,
                    kind: "m",
                    height: iconHeight,
                    width: iconWidth,
                    color: iconColor,
                };
                normalizedAdvantage['Glyph-1'] = iconObject;
                if (title) {
                    normalizedAdvantage["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-2"]), { text: title });
                }
                if (description) {
                    normalizedAdvantage["Text-2"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-3"]), { text: description });
                }
                normalizedInfo[`Advantage-${index + 1}`] = normalizedAdvantage;
            });
            res = normalizedInfo;
        }
        return res;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.advantagesNormalizer = advantagesNormalizer;
exports.default = exports.advantagesNormalizer;
//# sourceMappingURL=index.js.map